/**
 * Ellipsis Icon — Three horizontal dots.
 *
 * Used for "more options" menus.
 * Compatible with Lucide icon API (size + color props).
 *
 * @example
 * <EllipsisIcon size={16} />
 */
export const EllipsisIcon = ({ size = 16, color }: { size?: number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.67C8.37 8.67 8.67 8.37 8.67 8C8.67 7.63 8.37 7.33 8 7.33C7.63 7.33 7.33 7.63 7.33 8C7.33 8.37 7.63 8.67 8 8.67Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.67 8.67C13.03 8.67 13.33 8.37 13.33 8C13.33 7.63 13.03 7.33 12.67 7.33C12.3 7.33 12 7.63 12 8C12 8.37 12.3 8.67 12.67 8.67Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33 8.67C3.7 8.67 4 8.37 4 8C4 7.63 3.7 7.33 3.33 7.33C2.97 7.33 2.67 7.63 2.67 8C2.67 8.37 2.97 8.67 3.33 8.67Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
